import { formatNumber } from './format'

const SEPARATOR = ';'

function cell(value) {
  const text = value === null || value === undefined ? '' : String(value)

  return /[";\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text
}

function row(values) {
  return values.map(cell).join(SEPARATOR)
}

// Número com vírgula decimal, para abrir corretamente em planilhas em pt-BR.
function num(value) {
  return typeof value === 'number' ? String(formatNumber(value)).replace('.', ',') : ''
}

export function buildResultCsv(result) {
  const lines = [
    row(['Quadro', 'Número', 'Nome', 'Tensão (V)', 'Potência instalada (W)', 'Corrente (A)', 'Proteção (A)', 'Cabo']),
  ]

  result.boards.forEach((board) => {
    board.circuits.forEach((c) => {
      lines.push(
        row([board.name, c.id, c.name, c.tension, c.totalPower, c.electricCurrent, c.breaker?.current, c.wire?.name])
      )
    })
  })

  lines.push(
    '',
    row(['Quadro', 'IDR', 'Nome', 'Escopo', 'Circuitos', 'Corrente requerida (A)', 'Corrente nominal (A)', 'Polos'])
  )

  result.boards.forEach((board) => {
    ;(board.idrs || []).forEach((idr) => {
      lines.push(
        row([
          board.name,
          idr.id,
          idr.name,
          idr.scope,
          (idr.circuitIndexes || []).map((i) => board.circuits[i]?.id).join(', '),
          num(idr.requiredCurrent),
          idr.nominalCurrent,
          idr.poles,
        ])
      )
    })
  })

  return lines.join('\r\n')
}

export function downloadResultCsv(result) {
  const blob = new Blob(['﻿', buildResultCsv(result)], { type: 'text/csv;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = url
  link.download = 'Resultado Circuitos Elétricos.csv'
  link.click()
  URL.revokeObjectURL(url)
}
